import React from "react";
import "../styles/MemorialBooklet.css";

const PDF_URL = "/media/memorial-booklet/father-paul-oneid-memorial-booklet.pdf";
const PAGES = Array.from({ length: 8 }, (_, index) => ({
  number: index + 1,
  image: `/media/memorial-booklet/page-${index + 1}.png`,
}));

export default function MemorialBooklet() {
  return (
    <section className="memorial-booklet" aria-labelledby="memorial-booklet-title">
      <header className="memorial-booklet__header">
        <p>In Loving Memory</p>
        <h1 id="memorial-booklet-title">Memorial Booklet</h1>
        <p className="memorial-booklet__description">
          An eight-page remembrance of Reverend Father Paul Oneid’s life, family,
          ministry, and seventy-five years of priestly service.
        </p>
        <a className="memorial-booklet__pdf-link" href={PDF_URL} target="_blank" rel="noreferrer">
          Open the complete PDF
        </a>
      </header>

      <div className="memorial-booklet__pages">
        {PAGES.map((page) => (
          <figure className="memorial-booklet__page" key={page.number}>
            <a
              href={page.image}
              target="_blank"
              rel="noreferrer"
              aria-label={`Open memorial booklet page ${page.number} at full size`}
            >
              <img
                src={page.image}
                alt={`Father Paul Oneid memorial booklet, page ${page.number} of 8`}
                loading={page.number <= 2 ? "eager" : "lazy"}
              />
            </a>
            <figcaption>Page {page.number} of 8</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
